import { joinURL, withTrailingSlash } from 'ufo'

/**
 * Cache storage.
 */
const API_CACHE = new Map<string, any>()

/**
 * A simple re-usable fetch method.
 */
export async function apiFetch<T>(path: string, query?: Record<string, any>) {
    /**
     * Make the URL.
     */
    function makeUrl(path: string) {
        const url = import.meta.env.DEV
            ? new URL(joinURL('/api', path), import.meta.url)
            : new URL(path, withTrailingSlash('/wp-json/minderberg/gsi/v1'))

        if (query) {
            for (const [key, value] of Object.entries(query)) {
                if (Array.isArray(value)) {
                    value
                        .filter(Boolean)
                        .forEach(v =>
                            url.searchParams.append(`${key}[]`, String(v))
                        )
                } else if (value) {
                    url.searchParams.set(key, String(value))
                }
            }
        }

        return url.toString()
    }

    /**
     * Fetch the data.
     */
    async function run() {
        const url = makeUrl(path)

        if (!API_CACHE.has(url)) {
            const res = await fetch(url)
            const data = await res.json()
            API_CACHE.set(url, data as T)
        }

        return API_CACHE.get(url) as T
    }

    if (import.meta.env.VITEST) return [] as unknown as T

    return await run()
}
